import { useTheme } from "@material-ui/core";
import { ReactNode } from "react";
import Joyride, { Locale, Props, STATUS } from "react-joyride";
import TourTooltip from "../TourTooltip";

export interface ITourProps extends Props {
  onFinishedOrSkipped?: () => void;
  children?: ReactNode;
  locale: Locale;
}

const Tour = (props: ITourProps) => {
  const {
    continuous = true,
    onFinishedOrSkipped = () => {},
    steps,
    locale,
    ...rest
  } = props;
  const theme = useTheme();

  return (
    <Joyride
      steps={steps}
      locale={locale}
      callback={(state) => {
        if (
          state.status === STATUS.SKIPPED ||
          state.status === STATUS.FINISHED
        ) {
          onFinishedOrSkipped();
        }
      }}
      continuous={continuous}
      tooltipComponent={TourTooltip}
      styles={{
        options: {
          arrowColor: theme.palette.tour.background,
        },
      }}
      {...rest}
    />
  );
};

export default Tour;
